/**
 * @generated SignedSource<<d63635b9a88f272212e49870652d5a71>>
 * @relayHash 3ff6a83713bbf763699a3ddd45e3c9ba
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ff6a83713bbf763699a3ddd45e3c9ba

import type { ConcreteRequest } from 'relay-runtime';
export type UpdateIssueCommentInput = {
  body: string;
  bodyVersion?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  id: string;
};
export type updateIssueCommentBodyMutation$variables = {
  input: UpdateIssueCommentInput;
};
export type updateIssueCommentBodyMutation$data = {
  readonly updateIssueComment: {
    readonly issueComment: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly viewerCanUpdate: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueCommentBodyMutation$rawResponse = {
  readonly updateIssueComment: {
    readonly issueComment: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly viewerCanUpdate: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueCommentBodyMutation = {
  rawResponse: updateIssueCommentBodyMutation$rawResponse;
  response: updateIssueCommentBodyMutation$data;
  variables: updateIssueCommentBodyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssueCommentPayload",
    "kind": "LinkedField",
    "name": "updateIssueComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IssueComment",
        "kind": "LinkedField",
        "name": "issueComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "unfurlReferences",
                "value": true
              }
            ],
            "kind": "ScalarField",
            "name": "bodyHTML",
            "storageKey": "bodyHTML(unfurlReferences:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bodyVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerCanUpdate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueCommentBodyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueCommentBodyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3ff6a83713bbf763699a3ddd45e3c9ba",
    "metadata": {},
    "name": "updateIssueCommentBodyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "57ff1e08ffa6efeff2ea43d80e6a0725";

export default node;
